"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _introspection_query = _interopRequireDefault(require("./introspection_query"));

var _utils = require("./utils");

var _default = (0, _utils.memoize)(function (client) {
  return client.query({
    query: (0, _graphqlTag.default)(_introspection_query.default)
  });
}, function () {
  return '__get_introspection_result';
});

exports.default = _default;